import { useContext } from "react";
import { GetPaymentLinkRequest } from "@shared/types";
import { sharedLib } from "@shared/services/shared.service";
import { BuySubscriptionContext } from "features/settings/Subscription/BuySubscription.context";

export const usePromoCodePrices = () => {
  const { setPromoCodePrices, promoCodePrices } = useContext(
    BuySubscriptionContext
  )!;

  const [getNewPaymentPrice, getNewPaymentPriceStatus] =
    sharedLib.sharedApi.settings.useLazyGetNewPaymentPriceQuery();

  const handleGetNewPaymentPrice = (
    args: Omit<GetPaymentLinkRequest, "email">,
    duration: number
  ) => {
    getNewPaymentPrice(args)
      .unwrap()
      .then((response) => {
        setPromoCodePrices((prevPrices) => ({
          ...prevPrices,
          [duration]: response,
        }));
        return response;
      })
      .catch((response) => {
        setPromoCodePrices((prevPrices) => ({
          ...prevPrices,
          [duration]: { message: response.data.message },
        }));
      });
  };

  return {
    handleGetNewPaymentPrice,
    getNewPaymentPriceStatus,
    promoCodePrices,
  };
};
